module.exports = __webpack_public_path__ + "img/logo-pc.8982fa74.svg";